import React from "react";

//libraries
import { Helmet } from "react-helmet-async";

//styles
import "./BioScreen.scss";

//content and images
import { about } from "./about";

//components
import SingleBio from "./SingleBio";

const BioScreen = () => {
  return (
    <>
      <Helmet>
        <title>
          Meet the Team | Concierge Wellness Physical Therapy & Massage Therapy
        </title>

        <meta
          name="description"
          content="Meet the team behind Concierge Wellness in Colorado Springs. Learn more about Dr. Christian Wade, DPT, and Curt Mulick, LMT, and their shared commitment to helping clients move better, recover faster, and perform at their best."
        />

        <link rel="canonical" href="https://conciergewellnesspt.com/about" />

        <meta
          property="og:title"
          content="Meet the Team | Concierge Wellness"
        />

        <meta
          property="og:description"
          content="Learn more about the physical therapy and massage therapy professionals behind Concierge Wellness in Colorado Springs."
        />

        <meta
          property="og:url"
          content="https://conciergewellnesspt.com/about"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>
      <main className="bio" data-aos="fade-up" data-aos-duration="1000">
        {about.map((singleBio) => (
          <SingleBio about={singleBio} key={singleBio.alt} />
        ))}
      </main>
    </>
  );
};

export default BioScreen;
